import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { imgagesFolder } from 'src/app/core/services/globals';

@Component({
  selector: 'app-big-select',
  templateUrl: './big-select.component.html',
  styleUrls: ['./big-select.component.scss']
})
export class BigSelectComponent implements OnInit {
  @Input() selected: number;
  @Input() placeholder: string;
  @Input() items: BigSelectInput[];
  @Input() isMobile: boolean;
  @Output() valueChange = new EventEmitter();
  @Input() translationString: string;
  @Input() elementClass: string;

  noPlaceHolderItems: BigSelectInput[];

  constructor(public breakpointObserver: BreakpointObserver) {}

  ngOnInit() {
    this.noPlaceHolderItems = this.items.slice(1);
  }

  selectedClass(selectedId) {
    const cls = this.selected === selectedId ? 'selected' : '';
    return cls;
  }

  imgUrl(fileName, selectedId) {
    let url = imgagesFolder;
    url += fileName;
    url += this.selected === selectedId ? '-selected.svg' : '.svg';
    return url;
  }

  valueChanged(id) {
    this.valueChange.emit(id);
  }
}

interface BigSelectInput {
  id: number;
  name: string;
  fileName: string;
}
